import type { IExtractRouteParamMap, IRouteTranslation } from "../../types";
import { createBreadcrumbObject, createPaths } from "../../utils";

// Base route constant
const baseRoute = `/change-password`;

// * Route configuration object for changePassword-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const changePasswordRoutesObj = {
  home: baseRoute,
} as const;

// ! these are breadcrumbs translation not page title
const changePasswordRouteTranslation: IRouteTranslation<
  typeof changePasswordRoutesObj
> = {
  home: "changePassword",
};

// * Extracts the route parameters for the changePassword route configuration.
export type IChangePasswordRouteParams = IExtractRouteParamMap<
  typeof changePasswordRoutesObj
>;

// * Path functions for the changePassword routes.
export const changePasswordPath = createPaths<
  typeof changePasswordRoutesObj,
  IChangePasswordRouteParams
>(changePasswordRoutesObj);

// * Breadcrumbs {translation and route} for the faculty routes
export const changePasswordBreadcrumbs = createBreadcrumbObject<
  typeof changePasswordRoutesObj
>(changePasswordRoutesObj, changePasswordRouteTranslation);
